import MuiSwitch, { SwitchProps as MuiSwitchProps } from '@mui/material/Switch'
import React from 'react'

export type ToggleSwitchProps = MuiSwitchProps
const ToggleSwitch = ({ ...rest }: ToggleSwitchProps): React.ReactElement => (
  <MuiSwitch {...rest} />
)

export default ToggleSwitch
